import { render } from "./SurveyRadio.vue?vue&type=template&id=97ca015e&scoped=true"
import script from "./SurveyRadio.vue?vue&type=script&lang=js"
export * from "./SurveyRadio.vue?vue&type=script&lang=js"

import "./SurveyRadio.vue?vue&type=style&index=0&id=97ca015e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-97ca015e"

export default script